import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from '../button/button.component';

export type ConfirmModalVariant = 'primary' | 'danger';
export type ConfirmModalSize = 'sm' | 'md' | 'lg' | 'xl' | '2xl';

@Component({
  selector: 'app-confirm-modal',
  standalone: true,
  imports: [CommonModule, TranslatePipe, ButtonComponent],
  templateUrl: './confirm-modal.component.html',
})
export class ConfirmModalComponent {
  @Input() isOpen = false;
  @Input() title = '';
  @Input() message = '';
  @Input() itemName?: string;
  @Input() confirmLabel = 'CONFIRM_MODAL.CONFIRM';
  @Input() cancelLabel = 'CONFIRM_MODAL.CANCEL';
  @Input() variant: ConfirmModalVariant = 'primary';
  @Input() loading = false;
  @Input() size: ConfirmModalSize = 'xl';
  @Input() maxWidth?: string;

  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  get modalSizeClass(): string {
    if (this.maxWidth) {
      return this.maxWidth;
    }
    switch (this.size) {
      case 'sm':
        return 'max-w-sm';
      case 'md':
        return 'max-w-md';
      case 'lg':
        return 'max-w-lg';
      case 'xl':
        return 'max-w-xl';
      case '2xl':
        return 'max-w-2xl';
      default:
        return 'max-w-lg';
    }
  }

  onConfirm(): void {
    if (!this.loading) {
      this.confirmed.emit();
    }
  }

  onCancel(): void {
    if (!this.loading) {
      this.cancelled.emit();
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.isOpen && !this.loading) {
      this.onCancel();
    }
  }
}
